// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SurveyAnswer {
    static getAttributeTypeMap() {
        return SurveyAnswer.attributeTypeMap;
    }
}
SurveyAnswer.discriminator = undefined;
SurveyAnswer.attributeTypeMap = [
    {
        "name": "key",
        "baseName": "key",
        "type": "string"
    },
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    }
];
//# sourceMappingURL=surveyAnswer.js.map